import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import { memo } from "react"
import styled from "styled-components"

const InfoGroup = styled.div`
  display: grid;
`

interface Props {
  mainText: string
  labelText?: string
}
const UserArea = (props: Props) => {
  const { mainText, labelText } = props

  return (
    <InfoGroup>
      <Heading variant="h6">{mainText}</Heading>
      <BodyText size="semi-medium">{labelText}</BodyText>
    </InfoGroup>
  )
}

export default memo(UserArea)
